(() => {
  function boot(root = document) {
    root.querySelectorAll('[data-wn-merch-upsell]').forEach((panel) => {
      if (panel.dataset.ready === 'true') return;
      panel.dataset.ready = 'true';
      const message = panel.querySelector('[data-wn-merch-message]');
      panel.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-wn-merch-add]');
        if (!button) return;
        event.preventDefault();
        if (!window.WNCart?.add || button.disabled) return;
        const id = Number(button.dataset.variantId || 0);
        if (!id) return;
        const original = button.dataset.label || button.textContent;
        button.disabled = true;
        button.textContent = button.dataset.loadingLabel || original;
        if (message) message.textContent = '';
        try {
          await window.WNCart.add({ items: [{ id, quantity: 1 }] }, { source: 'product-upsell', openDrawer: true });
          button.textContent = button.dataset.addedLabel || original;
          button.classList.add('is-added');
        } catch (error) {
          button.disabled = false;
          button.textContent = original;
          if (message) message.textContent = error?.message || panel.dataset.errorLabel || '';
        }
      });
    });
  }
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
})();
